export default "__VITE_ASSET__BYEB4aUj__"